export const GET_EXAM = `/admin/exam`
export const GET_CENTRE = `/admin/exam/centre`
export const GET_SLOTS = `/admin/exam/slots`
export const GET_AADHAR = `/admin/user/`
export const GET_SUBJECT = `/admin/user/subject/`
export const GET_LOGIN_STATUS = `/admin/exam/login-status`
export const ADD_APPROVE_ANSWER = `admin/exam/approve-answers/`
export const GET_RELOGIN_OTP = "/admin/exam/relogin-otp"

export const GET_LEGACY_EXAM = `admin/exam/legacy/`

export const UPDATE_MARKS = `admin/exam/marks`


export const GET_FEEDBACK = `/admin/exam/feedback/`
export const GET_ADMIT_CARD = `admin/exam/admit-card/`



export const GET_CANDIDATE_PER_EXAM = `admin/exam/candidates`
export const GET_LEGACY_CANDIDATE_PER_EXAM = `admin/exam/candidates-legacy`
export const GET_SUBJECTS_PER_EXAM = `admin/exam/subjects/`
export const GET_DATE_PER_EXAM = `/exam/date/`
export const ADD_ALLOTMENT = `admin/exam/allotment/`
export const DELETE_SLOT = `/admin/exam/slot/`
export const GET_USER = `/admin/user/`

export const ADD_PASSWORD = "admin/auth/exam-app"

export const UPLOAD_ATTENDANCE = "admin/exam/attendance"
export const GET_WAITLIST = "/waitlist"


export const EXTEND_EXAM_TIME = "admin/exam/extend-time"
